var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "typeahead-field-edit basic-field-edit" }, [
    _c(
      "div",
      { staticClass: "typeahead-field-container form-group" },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputValue,
              expression: "inputValue",
            },
          ],
          ref: "typeahead",
          staticClass: "typeahead-field-input",
          attrs: {
            name: "product-select-typeahead",
            type: "text",
            placeholder: "Search",
          },
          domProps: { value: _vm.inputValue },
          on: {
            focus: function ($event) {
              return _vm.focus()
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.inputValue = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.showTypeahead
            ? _c(
                "div",
                { staticClass: "typeahead-field-options" },
                _vm._l(_vm.matchedOptions, function (option, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "typeahead-field-option",
                      on: {
                        click: function ($event) {
                          return _vm.selectOption(option.nid)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "select-product-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.title) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "select-product-subtitle" }, [
                        _c("small", [
                          _vm._v(
                            "SKU: " +
                              _vm._s(option.productsettings.sku) +
                              " || NID: " +
                              _vm._s(option.nid) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }